// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2870) return "static/chunks/2870-21ddab662e991bd5.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "61a4133db2c2b2ce" + ".js";
};